import { CommonApiBadRequestErrors, CommonErrorMessages } from '../../constants';

export default class ErrorsHelper {
  public static getErrorMessageFromErrorObject(errorObject: string | Error | unknown): string {
    let errorObjectAsString = '';

    if (typeof errorObject === 'string') {
      errorObjectAsString = (errorObject || '').trim();
    } else if (errorObject instanceof Error) {
      errorObjectAsString = errorObject.message;
    }

    if (!errorObjectAsString) {
      return CommonErrorMessages.General;
    }

    // NOTE: The error.message property can have JSON data,
    // so we just use a basic 'includes' logic here
    if (errorObjectAsString.toLowerCase().includes('failed to fetch')) {
      return CommonErrorMessages.General;
    } else if (errorObjectAsString.toLowerCase().includes(CommonApiBadRequestErrors.NotLoggedIn.toLowerCase())) {
      return CommonErrorMessages.NotLoggedIn;
    } else if (errorObjectAsString.toLowerCase().includes(CommonApiBadRequestErrors.NoMatchingAdvisor.toLowerCase())) {
      return CommonErrorMessages.NoMatchingAdvisor;
    }

    return errorObjectAsString;
  }
}
